import { render, staticRenderFns } from "./fieldCustomSelect.vue?vue&type=template&id=68957819&"
import script from "./fieldCustomSelect.vue?vue&type=script&lang=js&"
export * from "./fieldCustomSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports